import { ProductSwiper } from '../../../common/ui/ProductSwiper';
import { mapRemoteData } from '../../../common/domain/RemoteData.model';
import { fetchAllBis } from '../../catalog/infrastructure/CatalogService';
import { useComercialContext } from '../../../comercial/ComercialContext';

const LOT_PROMOTION_FILTER = {
  characteristics: {
    hasActiveLotPromotion: true
  }
};

export const LotPromotionProductsSwiper = () => {
  const { actingAsCliente } = useComercialContext();
  const actingAsNumCliente = actingAsCliente?.numCliente ?? null;
  const fetchFn = () =>
    fetchAllBis(LOT_PROMOTION_FILTER, { amount: 50, page: 0 }, actingAsNumCliente)
      .then(rd => mapRemoteData(rd, ({ content }) => content));
  return (
    <ProductSwiper title={'PROMOCIONES POR LOTES'} fetchFn={fetchFn} />
  );
};
